import {$events} from '../../helpers/events';
import {$dom} from '../../helpers/dom';
import {preventDefault} from '../../helpers/_utilities';
import {$style} from '../../helpers/style';
import variables from '../../variables';
import is from 'is_js';
import SmoothScrollbar from 'smooth-scrollbar';

const {
	attr,
	exist,
	get
} = $dom;

const {mainScrollElementId} = variables.selectors;

export default function scrollTo(buttonAttr = 'data-scroll-to', buttonSelector = `[${buttonAttr}]`) {

	if (exist(buttonSelector)) {

		function handleClick(event) {
			preventDefault(event);
			const btn = event.target.closest(buttonSelector);

			const scrollTargetSelector = attr(btn, buttonAttr);

			if (exist(scrollTargetSelector)) {
				const scrollTarget = get(scrollTargetSelector), topPos = $style.offset(scrollTarget).top;
				let targetScrollYDistance;

				if (is.touchDevice()) {
					window.scrollTo({
						top: topPos,
						behavior: 'smooth'
					});
				} else {
					const customScroll = SmoothScrollbar.get(get('#'+mainScrollElementId));

					if (customScroll) {
						targetScrollYDistance = topPos + customScroll.offset.y;
						customScroll.scrollTo(0, targetScrollYDistance, variables.carouselDefaultDuration * 3)
					}
				}
			}
		}

		const
			init = () => {
				$events.delegate.on('click tap', buttonSelector, handleClick)
			},
			destroy = () => {
				$events.delegate.off('click tap', buttonSelector, handleClick)
			}
		;

		return {init, destroy}
	}

	return  null;
}
